export type BasketProposalDownload = {
  url: string;
  text: string;
};

export type BasketProposalCover = {
  name: string;
  tooltip: string;
  hasTooltip: boolean;
  value: string;
  renderingType: number;
  amountType?: number;
  groupedCovers?: BasketProposalCover[];
};

export type BasketProposalDeductible = {
  amount: string;
  isPresented: boolean;
};

export enum PaymentIntervalId {
  Yearly = 1000009,
  HalfYearly = 1000007,
  Quarterly = 1000008,
  Monthly = 1000006
}

export type BasketProposalPaymentInterval = {
  id: PaymentIntervalId;
  description: string;
};

export type BasketProposalPaymentInformation = {
  selectedPaymentInterval: BasketProposalPaymentInterval;
  paymentIntervals: BasketProposalPaymentInterval[];
};

export type BasketProposalClause = {
  id: number;
  title: string;
  description: string;
};

export type BasketProposalDocument = {
  title: string;
  link: string;
};

export type BasketProposal = {
  id: string;
  name: string;
  type: string;
  productType: number;
  details: string;
  price: number;
  fees: number;
  document?: BasketProposalDocument;
  deductible: BasketProposalDeductible;
  externalProposalNumber: string;
  clauses: BasketProposalClause[];
  downloads: BasketProposalDownload[];
  covers: BasketProposalCover[];
  paymentInformation: BasketProposalPaymentInformation;
  productInformation: string;
  isDigitallyCreated: boolean;
  showYearZeroText: boolean | null;
};

export type ProposalBasketStoreState = {
  proposals: BasketProposal[];
  proposalsInBasket: number;
  digitalProposalsInBasket: number;
  manualProposalsInBasket: number;
  areAllProposalsManual: boolean;
  updateComponentVsBasket: boolean;
  selectedProposals: string[];
  showRemoveProposalErrorModal: boolean;
  selectedPaymentIntervals: { [proposalId: string]: BasketProposalPaymentInterval };
  showRemoveProposalSuccessModal: boolean;
  index: number;
};
